import { Stack } from '@lyearn/ui';

const FtbPlayerContainer: React.FC<React.PropsWithChildren> = ({ children }) => {
  return (
    <Stack alignItems="center" className="flex-wrap xs:px-20">
      {children}
    </Stack>
  );
};

export default FtbPlayerContainer;
